// extracted by mini-css-extract-plugin
export default {"host":"_1ZlqisjHzluINuyJmoD7Fr","view":"_3RH8IVp0_i81rrS8z9zWXz"};